<template>
    <main class="technology-view">
        <header class="cover technology-cover">
            <div class="cover-bg" :style="styles.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.technology.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.technology.subtitle') }}</h2>
            </div>
        </header>
        <div class="body">
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#research-development', 'down')"></v-waypoint>
                <div id="research-development" class="text-block text-block-01 text-block-rd">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.technology.text-block-01.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.technology.text-block-01.body')"></p>
                        <br>
                        <a class="action-button" :href="$t('links.rd.url')">
                            <img src="~@/assets/images/plus-circle-o.svg">
                        </a>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#research-development', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#intelligent-manufacturing', 'down')"></v-waypoint>
                <div class="image-block image-block-01">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image01.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image01.md}`" />
                        <img :src="`${assets.image01.xs}`"/>
                    </picture>
                </div>
                <div id="intelligent-manufacturing" class="text-block text-block-02 text-block-intelligent">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.technology.text-block-02.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.technology.text-block-02.body')"></p>
                        <br>
                        <a class="action-button" :href="$t('links.intelligent-manufacturing.url')">
                            <img src="~@/assets/images/plus-circle-o.svg">
                        </a>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#intelligent-manufacturing', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#global-presence', 'down')"></v-waypoint>
                <div class="image-block image-block-02">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image02.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image02.md}`" />
                        <img :src="`${assets.image02.xs}`"/>
                    </picture>
                    <img class="ruyi-logo d-none d-md-block mx-auto" src="~@/assets/images/logos/ruyi-o.svg">
                </div>
                <div id="global-presence" class="text-block text-block-03 text-block-global-presence">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.technology.text-block-03.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.technology.text-block-03.body')"></p>
                        <br>
                        <a class="action-button" :href="$t('links.global-presence.url')">
                            <img src="~@/assets/images/plus-circle-o.svg">
                        </a>
                    </div>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#global-presence', 'up')"></v-waypoint>
            </section>
            <section>
                <v-waypoint class="vue-waypoint__waypoint--top" @waypoint-in="updateInPageNav('#vertical-integration', 'down')"></v-waypoint>
                <div class="image-block image-block-03">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image03.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image03.md}`" />
                        <img :src="`${assets.image03.xs}`"/>
                    </picture>
                </div>
                <div id="vertical-integration" class="text-block text-block-04 text-block-vertical">
                    <h3 class="text-block-title text-block-title-underline">{{ $t('pages.technology.text-block-04.title') }}</h3>
                    <div class="text-block-body">
                        <p v-html="$t('pages.technology.text-block-04.body')"></p>
                        <br>
                        <a class="action-button" :href="$t('links.vertical-integration.url')">
                            <img src="~@/assets/images/plus-circle-o.svg">
                        </a>
                    </div>
                </div>
                <div class="image-block image-block-04">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image04.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image04.md}`" />
                        <img :src="`${assets.image04.xs}`"/>
                    </picture>
                </div>
                <div class="image-block image-block-05">
                    <picture>
                        <source media="(min-width: 1280px)" :srcset="`${assets.image05.xl}`" />
                        <source media="(min-width: 768px)" :srcset="`${assets.image05.md}`" />
                        <img :src="`${assets.image05.xs}`"/>
                    </picture>
                </div>
                <v-waypoint class="vue-waypoint__waypoint--bottom" @waypoint-in="updateInPageNav('#vertical-integration', 'up')"></v-waypoint>
            </section>
        </div>
        <in-page-nav :links="inPageLinks" :active="inPageNavActive" />
    </main>
</template>

<script>
  import InPageNav from '../widgets/InPageNav.vue'
  import getMatchedBreakpoint from '../mixins/getMatchedBreakpoint'
  import updateHead from '../mixins/updateHead'
  import updateInPageNav from '../mixins/updateInPageNav'

  export default {
    computed: {
      styles () {
        return {
          coverBg: {
            backgroundImage: `url(${this.assets.cover[this.matchedBreakpoint]})`
          }
        }
      },
      assets () {
        return {
          cover: {
            xs: this.$t('pages.technology.cover.xs'),
            md: this.$t('pages.technology.cover.md'),
            xl: this.$t('pages.technology.cover.xl')
          },
          image01: {
            xs: this.$t('pages.technology.image-block-01.xs'),
            md: this.$t('pages.technology.image-block-01.md'),
            xl: this.$t('pages.technology.image-block-01.xl')
          },
          image02: {
            xs: this.$t('pages.technology.image-block-02.xs'),
            md: this.$t('pages.technology.image-block-02.md'),
            xl: this.$t('pages.technology.image-block-02.xl')
          },
          image03: {
            xs: this.$t('pages.technology.image-block-03.xs'),
            md: this.$t('pages.technology.image-block-03.md'),
            xl: this.$t('pages.technology.image-block-03.xl')
          },
          image04: {
            xs: this.$t('pages.technology.image-block-04.xs'),
            md: this.$t('pages.technology.image-block-04.md'),
            xl: this.$t('pages.technology.image-block-04.xl')
          },
          image05: {
            xs: this.$t('pages.technology.image-block-05.xs'),
            md: this.$t('pages.technology.image-block-05.md'),
            xl: this.$t('pages.technology.image-block-05.xl')
          }
        }
      },
      inPageLinks () {
        return [
          {
            title: this.$t('pages.technology.text-block-01.title'),
            hash: '#research-development'
          },
          {
            title: this.$t('pages.technology.text-block-02.title'),
            hash: '#intelligent-manufacturing'
          },
          {
            title: this.$t('pages.technology.text-block-03.title'),
            hash: '#global-presence'
          },
          {
            title: this.$t('pages.technology.text-block-04.title'),
            hash: '#vertical-integration'
          }
        ]
      }
    },
    head: {
      title () {
        return {
          inner: this.$t('pages.technology.title'),
          complement: this.$t('common.ruyi-group')
        }
      }
    },
    components: {
      InPageNav
    },
    mixins: [
      getMatchedBreakpoint,
      updateHead,
      updateInPageNav
    ]
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .technology-view {
        .text-block {
            &-intelligent {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-left: px2rem(356px);
                    margin-right: px2rem(35px);
                    margin-top: px2rem(-300px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(590px);
                    margin-top: px2rem(-450px);
                }

                .text-block-title {
                    @include media-breakpoint-up(md) {
                        max-width: calc(100% - 160px);
                    }
                }

                .text-block-body {
                    @include media-breakpoint-up(md) {
                        max-width: px2rem(420px);
                        min-width: px2rem(280px);
                        width: calc(100% - 160px);
                    }

                    @include media-breakpoint-up(xl) {
                        max-width: px2rem(720px);
                        min-width: px2rem(480px);
                    }
                }
            }

            &-vertical {
                @include media-breakpoint-up(md) {
                    border: 1px solid $black;
                    margin-left: px2rem(378px);
                    margin-right: px2rem(35px);
                    margin-top: px2rem(-15px);
                    padding-left: px2rem(30px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(630px);
                    margin-right: px2rem(60px);
                }

                .text-block-title {
                    @include media-breakpoint-up(xl) {
                        max-width: calc(100% - 160px);
                    }
                }

                .text-block-body {
                    @include media-breakpoint-up(md) {
                        max-width: px2rem(360px);
                        min-width: px2rem(240px);
                        width: calc(100% - 160px);
                    }

                    @include media-breakpoint-up(xl) {
                        max-width: px2rem(720px);
                        min-width: px2rem(360px);
                    }
                }
            }
        }

        .image-block {
            &-01 {
                @include media-breakpoint-up(md) {
                    width: px2rem(379px);
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(631px);
                }
            }

            &-02 {
                @include media-breakpoint-up(md) {
                    margin-top: px2rem(100px);
                    margin-left: auto;
                    margin-right: auto;
                    width: px2rem(579px);
                }

                @include media-breakpoint-up(xl) {
                    width: px2rem(964px);
                }

                .ruyi-logo {
                    transform: translateY(-50%);

                    @include media-breakpoint-up(md) {
                        width: px2rem(50px);
                    }

                    @include media-breakpoint-up(md) {
                        width: px2rem(100px);
                    }
                }
            }

            &-04 {
                @include media-breakpoint-up(md) {
                    margin-top: px2rem(-345px);
                    width: px2rem(418px);
                }

                @include media-breakpoint-up(xl) {
                    margin-top: px2rem(-500px);
                    width: px2rem(696px);
                }
            }

            &-05 {
                margin-left: auto;
                margin-top: px2rem(-50px);
                width: 70%;

                @include media-breakpoint-up(md) {
                    margin-left: px2rem(378px);
                    margin-top: px2rem(-125px);
                    width: px2rem(315px);
                }

                @include media-breakpoint-up(xl) {
                    margin-left: px2rem(630px);
                    margin-top: px2rem(-225px);
                    width: px2rem(524px);
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Technology.vue?1ff9921f